
import React from "react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface TwilioErrorAlertProps {
  error: string;
}

/**
 * Component for displaying Twilio-specific errors with troubleshooting guidance
 */
const TwilioErrorAlert = ({ error }: TwilioErrorAlertProps) => {
  // Detect specific Twilio authentication errors
  const isAuthError = error.toLowerCase().includes("authenticate") || 
                     error.toLowerCase().includes("unauthorized") ||
                     error.toLowerCase().includes("auth");

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Twilio Error</AlertTitle>
      <AlertDescription>
        <div className="space-y-2">
          <p>{error}</p>
          
          {isAuthError && (
            <div className="text-sm bg-destructive/10 p-2 rounded">
              <strong>Troubleshooting:</strong>
              <ul className="list-disc pl-5 mt-1">
                <li>Verify your Twilio Account SID and Auth Token are correct</li>
                <li>Check that your Twilio account is active and not in trial mode</li>
                <li>Ensure the encryption keys match between frontend and edge functions</li>
              </ul>
            </div>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
};

export default TwilioErrorAlert;
